// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1fgEX","list":"PatternAutocomplete_list__2OkaY"};